import {
    SsoManager,
    SsoManagerFactory,
    IUserManagerConfig
} from '@diligent/sso-login/dist/index.js'
import {
    getSessionStorageItem,
    removeLocalStorageItem,
    removeSessionStorageItem
} from 'businesslayer/minutesLocalStore'
import { transientStorageManager } from 'businesslayer/minutesSessionStore'
// import ConfigurationManager from 'services/ConfigurationManager';
import ssoConfig from '../../config/ssoConfig.json'

export interface ISsoState {
    returnUrl: string
    onboardingCompleteRedirectUrl?: string
}

export interface ClientConfiguration {
    authority: string
    clientId: string
    scope: string
    accountSecurityUrl: string
}

class SsoManagerFactoryService {
    public async create(): Promise<SsoManager> {
        const ssoManagerFactory: SsoManagerFactory = new SsoManagerFactory()
        const config = this.createConfig()

        return ssoManagerFactory.create(config, {
            logger: console
        })
    }

    private createConfig(): IUserManagerConfig {
        const SSO_SCOPE_LIST = [
            'diligent_identity.manage_own_account',
            'openid',
            'profile',
            'security_questions_required',
            'diligent_id_claims',
            'diligent_identity.session_expiry',
            'diligent_identity.manage_own_account',
            'minutes_service.full_access'
        ]
        const { location, _env_ } = window
        const redirectUri = `${location.origin}/identity-login-callback`
        const postLogoutRedirectUri = location.origin
        //Note- This will only support Orca02 environment, please change its url to work with other environment.
        const SSO_AUTHORITY_URL =
            process.env.NODE_ENV !== 'development' ? _env_.SSO_AUTHORITY_URL : ssoConfig.authority

        const config: IUserManagerConfig = {
            authority: SSO_AUTHORITY_URL,
            clientId: 'minutes',
            redirectUri,
            postLogoutRedirectUri,
            responseType: 'code',
            scope: SSO_SCOPE_LIST.join(' '),
            automaticSilentRenew: true
        }
        return config
    }
}

const ssoManagerFactoryService = new SsoManagerFactoryService()

export const doLogin = async () => {
    const ssoManager = await ssoManagerFactoryService.create()
    ssoManager.signinRedirect()
}

export const doLogout = async () => {
    if (transientStorageManager.platform === 'boardeffect') {
        let destination = `/extensions/minutes?committee_id=${getSessionStorageItem(
            'currentCommitteeId'
        )}`
        window.location.href = `${
            transientStorageManager.parentAppUrl
        }/logout?destination=${encodeURIComponent(destination)}`
    } else {
        const ssomanager = await ssoManagerFactoryService.create()
        // ignore mock session for local developement
        if (process.env.NODE_ENV !== 'development') {
            ssomanager.signoutRedirect()
        } else {
            console.log('Do nothing for development')
        }
    }
    if (process.env.NODE_ENV !== 'development') {
        // Remove the selected filters for landing page
        removeLocalStorageItem('sessionId')
        removeSessionStorageItem('bookId')
        removeSessionStorageItem('committeeId')
        removeSessionStorageItem('committeeName')
        removeSessionStorageItem('selectedStatusFilter')
        removeSessionStorageItem('selectedCommitteeFilter')
        removeSessionStorageItem('persistedStateData')
    }
}

export const doSwitchSite = async (targetSite: string) => {
    const ssoManager = await ssoManagerFactoryService.create()
    const request: any = {
        acr_values: `tenant:${targetSite}`
    }
    ssoManager.signinRedirect(request)
}
export default ssoManagerFactoryService
